import React from "react"
import { CurrencyFormat } from "../../../Formatters"

export default function AboutData(minAge, maxAge, minCoverageAmount, maxCoverageAmount) {
    return {
        title: "About Final Expense Insurance",
        content:
            "Final expense insurance is a type of life insurance designed to help cover the expenses associated with one’s final arrangements and end-of-life costs. It provides a financial safety net to help ease the burden on loved ones during a difficult time. Final expense insurance policies typically offer smaller death benefits compared to traditional life insurance policies, ranging from a few thousand dollars to around $50,000. The coverage amount is intended to help cover funeral and burial expenses, as well as outstanding medical bills, legal fees, and other costs that may arise after one’s passing. Final expense insurance is often easier to qualify for compared to other types of life insurance, as it may not require a medical exam and has simplified underwriting. It provides peace of mind by ensuring that loved ones are not left with the financial strain of end-of-life expenses.",
        productData: [
           {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents ages ${minAge} - ${maxAge}`,
            },
            {
                title: "Coverage Lengths",
                text: "Whole Life",
            },
            {
                title: "Coverage amount",
                text: <span><CurrencyFormat number={minCoverageAmount} whole /> - <CurrencyFormat number={maxCoverageAmount} whole /></span>,
            },
            {
                title: "Death Benefit",
                text: "Lump sum payment that is typically paid tax free"
            }

        ]

    }
}
